import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_ME_67 } from "@/lib/programData";

export default function MarrakechErg67Page() {
  return <ProgramTemplate program={PROGRAM_ME_67} variant="me" showJourneyChronology />;
}
